import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { SITES } from '../../constants/routes';

const styles = () => ({
  card: {
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    flex: '1 0 auto',
    paddingBottom: '20px',
    paddingTop: '20px',
    fontSize: '2em',
  },
});

const DashboardSiteBlock = (props) => {
  const { classes } = props;
  return (
    <Grid item xs={12} sm={12} md={6} lg={3} className={classes.gridItem}>
      <Link to={`${SITES}/${props.id}`}>
        <Card className={classes.card} key={props.key}>
          <CardContent className={classes.content}>
            <Typography variant="h5" component="h2">
              {props.name}
            </Typography>
            <List>
              <ListItem>
                <ListItemText inset primary="Téléphone"
                              secondary={props.phone} />
              </ListItem>
              <ListItem>
                <ListItemText inset primary="Email"
                              secondary={props.email} />
              </ListItem>
              <ListItem>
                <ListItemText inset primary="Coordonnées"
                              secondary={`${props.latitude} . ${props.longitude}`} />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Link>
    </Grid>
  );
};

DashboardSiteBlock.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DashboardSiteBlock);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardSiteBlock.jsx